"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARRAYFORMULA = void 0;
exports.ARRAYFORMULA = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: (inputs) => {
        // For Finley formula engine, this is just a wrapper for a single input
        // Array inputs within the engine are already handled
        return { error: null, result: inputs[0] };
    },
};
//# sourceMappingURL=arrayformula.js.map